import PropTypes from 'prop-types';
import React from 'react';
import { useDictionary } from '../../../../../../utilities/hooks/UseDictionary';
import { useHistory } from 'react-router-dom';
import { AmountFormatHelper } from '../../../../../../utilities/helpers/AmountFormatHelper';
import { DateFormatHelper } from '../../../../../../utilities/helpers/DateFormatHelper';
import { countries } from '../../../../../../data/countries';
import { ReactComponent as StarFillIcon } from '../../../../../../assets/icons/ic_star.svg';
import { URI_GOOGLE_MAPS_PLACE_ID } from '../../../../../../config';
import { NavigatorPaths } from '../../../../../../assets/dictionaries/NavigatorPaths';

const ProviderDetailRight = ({ details }) => {
	const dictionary = useDictionary();
	const history = useHistory();
	const isSubscription =
		details?.is_subscription === true ||
		details?.is_subscription === 1 ||
		details?.is_subscription === '1';
	const currentPlan =
		details?.plan === 'enterprise'
			? dictionary.enterprise_plan
			: isSubscription
				? dictionary.business_plan
				: dictionary.basic;

	const formatAddress = (details, type) => {
		const { address1, address2, city, region, country_id } = details;
		const findCountryName =
			countries.find(country => country.key === country_id)?.value ?? '';

		if (type === 'address') {
			return [
				address1 + ',',
				address2 ? `${address2},` : '',
				city || ''
			].filter(Boolean).join('<br />');
		}

		return [
			region || '',
			findCountryName ? `, ${findCountryName}` : ''
		].filter(Boolean).join('');
	};

	const onPlaceClicked = (poiId) => {
		history.push(`/${NavigatorPaths.point_of_interests.path}/${poiId}`);
	};

	return (
		<div
			className="booking-experience-details-container"
			data-testid="booking-experience-details-container"
		>
			<div
				className="settings-tab-bar"
				style={{
					justifyContent: 'space-between',
					backgroundColor: 'white',
					alignItems: 'center',
					borderTopLeftRadius: 12,
					borderTopRightRadius: 12
				}}
			>
				<div
					className="settings-tab"
					style={{ color: 'var(--brand-dark-blue)', cursor: 'initial' }}
				>
					{dictionary?.details}
				</div>
				<div
					className="settings-tab"
				>
					<span onClick={() => window.open(details?.share_url, '_blank')} style={{ color: 'var(--brand-red)', cursor: 'pointer' }} className='text-with-underline'>{dictionary?.provider_list}</span>
				</div>
			</div>
			<div className="booking-experience-details-content-container thin-scrollbar">
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '2px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.providerReviews}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						<div className='d-flex items-center' style={{gap:4}}>
							<StarFillIcon width={12} height={12} style={{ color: '#22264C', padding:'2px 0px' }} />
							<span>{`${parseFloat(details.avg_reviews/100).toFixed(1)} (${details.total_reviews} ${dictionary.providerReviews.toLowerCase()})`}</span>
						</div>
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					{ details?.poi_id ? (
						<h4 className='text-with-underline' style={{ opacity: 0.6, fontWeight: 'normal', cursor: 'pointer' }} onClick={() => onPlaceClicked(details?.poi_id)}>
							{dictionary.Poi_Place_Id + ' - '}
							{(details.is_matched) ? '(Matched)' : '(Unmatched)'}
						</h4>
					) : (
						<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
							{dictionary.Poi_Place_Id + ' - '}
							{(details.is_matched) ? '(Matched)' : '(Unmatched)'}
						</h4>
					)}
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{details.place_id ? (
							<a
								target="_blank"
								rel="noreferrer"
								href={URI_GOOGLE_MAPS_PLACE_ID + details.place_id}
							>
								{details.place_id}
							</a>
						) : ''}
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.Poi_OBM}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details?.eligible ?? 'False'}
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.date_created}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? `${DateFormatHelper.monthYearTimeFormat(details.created_at)}` : '' }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.name}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? `${details.first_name} ${details.last_name}` : null }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.email}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? details.email : null }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.phone}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? details.phone : null }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.Mobile_Number}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? details.mobile : null }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.company}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? details.brand_name : null }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.vat_number}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? details.tax_id_number : null }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.account_iban}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? details.account_iban : null }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.beneficiary_name}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? details.account_beneficiary : null }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.upiria_commission}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? AmountFormatHelper.formatAmount(details.upiria_commission) : null }%
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.current_plan}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{currentPlan}
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.website}
					</h4>
					<h4 style={{ fontWeight: 'normal', textAlign: 'right' }}>
						{ details ? (
							<a 
								className='text-with-underline'
								href={details.website ? (details.website.startsWith('http://') || details.website.startsWith('https://') ? details.website : `https://${details.website}`) : '#'} 
								style={{ textDecoration: "none", color: '#22264c', cursor: 'pointer' }} 
								target="_blank" 
								rel="noreferrer"
							>
							{details.website}
						  </a>
						) : '-' }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.address}
					</h4>
					<h4 className='truncate provider-details-address' style={{ fontWeight: 'normal', textAlign: 'right' }} title={ details ? formatAddress(details,'address').replaceAll('<br />', '') : '-' } dangerouslySetInnerHTML={{ __html: formatAddress(details, 'address') }}>
						{/* { details ? formatAddress(details,'address') : '-' } */}
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.state}
					</h4>
					<h4 className='truncate provider-details-address' style={{ fontWeight: 'normal', textAlign: 'right' }} title={ details ? formatAddress(details,'region') : '-' }>
						{ details ? formatAddress(details,'region') : '-' }
					</h4>
				</div>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginTop: '24px' }}
				>
					<h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
						{dictionary.description}
					</h4>
					<h4 className='truncate provider-details-address' style={{ fontWeight: 'normal', textAlign: 'right' }} title={ details ? (details.short_description) : '-' }>
						{ details ? (details.short_description) : '-' }
					</h4>
				</div>
			</div>
		</div>
	);
};

ProviderDetailRight.propTypes = {
	details: PropTypes.object
};

export default ProviderDetailRight;
